import { formAddCsrfProtection } from "../../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	if (
		!!document.querySelector("#login_registration_container") &&
		!!document.querySelector("#user_nav #_user_panel_container") === false
	) {
		window.globalLoginWindowHandler.paywallLogin(
			document.querySelectorAll("#_paywall_redeem"),
		);
	}
	const form = document.querySelector("#_paywall_redeem_form");
	const submitButton = document.querySelector("#_paywall_redeem");
	const codeInput = document.querySelector("#id_promo_code");
	const checkConditions = document.querySelector("#id_service_conditions");
	const infoText = document.querySelector("#_info");
	form.addEventListener("submit", (event) => {
		event.preventDefault();
		submitButton.click();
	});
	submitButton.addEventListener("click", (event) => {
		event.preventDefault();
		submitButton.disabled = true;
		formAddCsrfProtection(form).then((data) => {
			const formData = new FormData(form);
			formData.set("service_conditions", checkConditions.checked ? 1 : 0);
			fetch(form.getAttribute("action"), {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				method: "POST",
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					const errorsDiv = document.querySelector("#_error_message");
					const successDiv = document.querySelector("#_success_message");
					const subs_page = document.querySelector("#_profile_subscriptions");
					errorsDiv.innerHTML = "";
					successDiv.innerHTML = "";
					if (data.errors) {
						submitButton.disabled = false;
						for (const error of data.errors) {
							errorsDiv.insertAdjacentHTML("beforeend", `${error}<br>`);
						}
						successDiv.classList.add("d-none");
						subs_page.classList.add("d-none");
						errorsDiv.classList.remove("d-none");
					} else {
						checkConditions.disabled = true;
						formToggle(false);
						document.querySelector("#id_promo_code").value = data.promo_code;
						successDiv.innerText = data.success_message;
						errorsDiv.classList.add("d-none");
						successDiv.classList.remove("d-none");
						subs_page.classList.remove("d-none");
					}
				});
		});
	});

	checkConditions.addEventListener("change", (event) => {
		formToggle(checkConditions.checked);
	});

	function formToggle(activate) {
		if (activate) {
			submitButton.disabled = false;
			codeInput.disabled = false;
			infoText.classList.remove("text-muted");
		} else {
			submitButton.disabled = true;
			codeInput.disabled = true;
			infoText.classList.add("text-muted");
		}
	}
});
